export default __webpack_public_path__ + "static/media/PowersTableImg.7e752204.PNG";